import axios from "axios";
import store from "@/store";
import customModal from "../customModal/customModal.vue";

export default {
    name: "ManageKRIModal",

    components: {
        customModal,
    },

    props: {
        riskEditData: {
            type: Object,
            default: null,
        },
        fromPage: {
            type: String,
            default: ""
        }
    },

    emits: ["closeModal", "reloadList"],

    computed: {
        isEditMode() {
            return !!this.form.id;
        },
        // ctqFieldsLocked() {
        //     return this.isEditMode || !!(this.riskEditData && this.riskEditData.ctqId);
        // },
        ctqFieldsLocked() {
            return this.fromPage === "kriInfoModal";
        },
    },

    data() {
        return {
            baseurl: process.env.VUE_APP_Service_URL,
            studyId: "",
            token: "",
            submitting: false,
            errors: {
                kriId: "",
                kriCalculationLogic: "",
                riskIndicator: "",
            },
            form: {
                id: "",
                kriId: "",
                ctqId: "",
                riskId: "",
                ctqFactor: "",
                riskIndicator: "",
                discussionDetails: "",
                kriCalculationLogic: "",
                unit: "",
                dataSource: "",
                aggregationLevel: "",
                coreOrExtendedKRI: "",
                generalOrSpecific: "",
                frequency: "",
                thresholdBasis: "",
                scorecard: "",
                weighting: "",
                typeOfRisk: "",
                isActive: true,
            },
        };
    },

    mounted() {
        this.studyId = store.getters.getStudyIs;
        this.token = store.getters.getIdToken;

        if (this.riskEditData) {
            this.form.id = this.riskEditData.id || "";
            this.form.ctqId = this.riskEditData.ctqId || "";
            this.form.riskId = this.riskEditData.riskId || "";
            this.form.ctqFactor = this.riskEditData.ctqFactor || "";
            this.form.kriId = this.riskEditData.kriId || "";
            this.form.riskIndicator = this.riskEditData.riskIndicator || "";
            this.form.discussionDetails = this.riskEditData.discussionDetails || "";
            this.form.kriCalculationLogic = this.riskEditData.kriCalculationLogic || "";
            this.form.unit = this.riskEditData.unit || "";
            this.form.dataSource = this.riskEditData.dataSource || "";
            this.form.aggregationLevel = this.riskEditData.aggregationLevel || "";
            this.form.coreOrExtendedKRI = this.riskEditData.coreOrExtendedKRI || "";
            this.form.generalOrSpecific = this.riskEditData.generalOrSpecific || "";
            this.form.frequency = this.riskEditData.frequency || "";
            this.form.thresholdBasis = this.riskEditData.thresholdBasis || "";
            this.form.scorecard = this.riskEditData.scorecard || "";
            this.form.weighting = this.riskEditData.weighting || "";
            this.form.typeOfRisk = this.riskEditData.typeOfRisk || "";
            this.form.isActive =
                this.riskEditData.isActive !== undefined ? this.riskEditData.isActive : true;
        }
    },

    methods: {
        closeModal() {
            this.$emit("closeModal");
        },

        clear() {
            this.errors.kriId = "";
            this.errors.kriCalculationLogic = "";
            this.errors.riskIndicator = "";
            this.form.kriId = "";
            this.form.riskId = "";
            this.form.riskIndicator = "";
            this.form.discussionDetails = "";
            this.form.kriCalculationLogic = "";
            this.form.unit = "";
            this.form.dataSource = "";
            this.form.aggregationLevel = "";
            this.form.coreOrExtendedKRI = "";
            this.form.generalOrSpecific = "";
            this.form.frequency = "";
            this.form.thresholdBasis = "";
            this.form.scorecard = "";
            this.form.weighting = "";
            this.form.typeOfRisk = "";
            this.form.isActive = true;
        },

        validate() {
            this.errors.kriId = "";
            this.errors.kriCalculationLogic = "";
            this.errors.riskIndicator = "";
            let isValid = true;
            if (!this.form.kriId || !this.form.kriId.trim()) {
                this.errors.kriId = "KRI ID is required.";
                isValid = false;
            }
            if (!this.form.kriCalculationLogic || !this.form.kriCalculationLogic.trim()) {
                this.errors.kriCalculationLogic = "KRI Calculation Logic is required.";
                isValid = false;
            }
            if (!this.form.riskIndicator || !this.form.riskIndicator.trim()) {
                this.errors.riskIndicator = "Risk Indicator is required.";
                isValid = false;
            }
            if (!isValid) {
                this.$nextTick(() => {
                    if (this.errors.kriId && this.$refs.kriId) {
                        this.$refs.kriId.scrollIntoView({
                            behavior: "smooth",
                            block: "center"
                        });
                        this.$refs.kriId.focus();
                    } 
                    else if (this.errors.riskIndicator && this.$refs.riskIndicator) {
                        this.$refs.riskIndicator.scrollIntoView({
                            behavior: "smooth",
                            block: "center"
                        });
                        this.$refs.riskIndicator.focus();
                    }
                    else if (this.errors.kriCalculationLogic && this.$refs.kriCalculationLogic) {
                        this.$refs.kriCalculationLogic.scrollIntoView({
                            behavior: "smooth",
                            block: "center"
                        });
                        this.$refs.kriCalculationLogic.focus();
                    } 
                });
            }
            return isValid;
        },

        async saveClicked() {
            if (!this.validate()) return;
            this.submitting = true;

            const payload = {
                studyId: this.studyId,
                kriId: this.form.kriId,
                ctqId: this.form.ctqId,
                riskId: this.form.riskId,
                ctqFactor: this.form.ctqFactor,
                riskIndicator: this.form.riskIndicator,
                discussionDetails: this.form.discussionDetails,
                kriCalculationLogic: this.form.kriCalculationLogic,
                unit: this.form.unit,
                dataSource: this.form.dataSource,
                aggregationLevel: this.form.aggregationLevel,
                coreOrExtendedKRI: this.form.coreOrExtendedKRI,
                generalOrSpecific: this.form.generalOrSpecific,
                frequency: this.form.frequency,
                thresholdBasis: this.form.thresholdBasis,
                scorecard: this.form.scorecard,
                weighting: this.form.weighting,
                typeOfRisk: this.form.typeOfRisk,
                isActive: this.form.isActive,
            };

            if (this.isEditMode) {
                payload.id = this.form.id;
            }

            try {
                const config = {
                    headers: {
                        Authorization: "Bearer " + this.token,
                        "Content-Type": "application/json",
                    },
                };

                if (this.isEditMode) {
                    await axios.put(`${this.baseurl}/forms/rbqm/updatekri`, payload, config);
                    alert("Key Risk Indicator updated successfully");
                } else {
                    await axios.post(`${this.baseurl}/forms/rbqm/createkri`, payload, config);
                    alert("Key Risk Indicator created successfully");
                }
                this.$emit("reloadList");
                this.closeModal();
            } catch (error) {
                console.error("Error saving KRI indicator:", error);
                alert("Failed to save Key Risk Indicator. Please check details and try again.");
            } finally {
                this.submitting = false;
            }
        },
    },
};